import React from 'react'
import { shallow } from 'enzyme'
import ProductRow from '../features/product/ProductRow'

describe('<ProductRow />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      productName: 'test',
      onEditClick: jest.fn()
    }
    wrapper = shallow(<ProductRow {...props} />)
  })
  it('should render the name of the provided product', () => {
    expect(wrapper.text()).toContain(props.productName)
  })
  it('should return something', () => {
    expect(ProductRow(props)).toBeTruthy()
  })
})
